<button
  [type]="type"
  [rounded]="rounded"
  [floating]="floating"
  mdbBtn
  mdbWavesEffect
  tabindex="0"
  [id]="id"
  [ngbTooltip]="tooltip"
  [color]="color"
  [size]="size"
  [disabled]="disabled || (spinner && !spinner.isStopped)"
  [classList]="_class"
  [class.disabled]="disabled || (spinner && !spinner.isStopped)"
  [outline]="outline"
  [block]="block"
  (click)="handleClick()"
  data-testid="bary-button"
>
  <span *ngIf="spinner">
    <span *ngIf="spinner && !spinner.isStopped" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
    <span *ngIf="spinner && !spinner.isStopped" class="ml-1"> {{ _spinnerLabel }}</span>
    <jhi-bary-icon *ngIf="icon && spinner.isStopped" [icon]="icon" [faDirective]="FAS" class="{{ label ? 'mr-1' : 'mr-0' }}"></jhi-bary-icon>
    <span *ngIf="spinner.isStopped">{{ label }}</span>
  </span>
  <span *ngIf="!spinner">
    <jhi-bary-icon *ngIf="icon" [icon]="icon" [faDirective]="FAS" class="{{ label ? 'mr-1' : 'mr-0' }}"></jhi-bary-icon>
    <span>{{ label }}</span>
  </span>
</button>
